export const SET_ASSESSMENT = "SET_ASSESSMENT"
export const SET_ASSESSMENTS = "SET_ASSESSMENTS"
export const UPDATE_ASSESSMENT = "UPDATE_ASSESSMENT"

export const ADD_COURSE = "ADD_COURSE"
export const ASSIGN_LEARNING_ITEMS = "ASSIGN_LEARNING_ITEMS"
export const ASSIGN_COURSES = "ASSIGN_COURSES"
export const DELETE_COURSE = "DELETE_COURSE"
export const SET_COURSES = "SET_COURSES"
export const SET_COURSE = "SET_COURSE"
export const UPDATE_COURSE = "UPDATE_COURSE"

export const SET_LEARNING_ITEMS = "SET_LEARNING_ITEMS"
export const ADD_LEARNING_ITEM = "ADD_LEARNING_ITEM"
export const DELETE_LEARNING_ITEM = "DELETE_LEARNING_ITEM"
export const UPDATE_LEARNING_ITEM = "UPDATE_LEARNING_ITEM"

export const ADD_LEARNING_ITEM_RESPONSE = "ADD_LEARNING_ITEM_RESPONSE"
export const DELETE_LEARNING_ITEM_RESPONSE = "DELETE_LEARNING_ITEM_RESPONSE"
export const UPDATE_LEARNING_ITEM_RESPONSE = "UPDATE_LEARNING_ITEM_RESPONSE"

export const SET_ME = "SET_ME"
export const SET_USER = "SET_USER"
export const UPDATE_USER = "UPDATE_USER"
export const SEND_USER_INVITE = "SEND_USER_INVITE"
export const ASSIGN_FAMILIES = "ASSIGN_FAMILIES"
export const ADD_USER_NOTE = "ADD_USER_NOTE"

export const SET_DOCUMENTS_AVAILABLE = "SET_DOCUMENTS_AVAILABLE"
export const SET_DOCUMENTS_SELECTED = "SET_DOCUMENTS_SELECTED"
export const ASSIGN_DOCUMENTS = "ASSIGN_DOCUMENTS"

export const SET_BADGES = "SET_BADGES"
export const ADD_BADGE = "ADD_BADGE"
export const DELETE_BADGE = "DELETE_BADGE"

export const SET_BUDGETS = "SET_BUDGETS"
export const SET_BUDGET = "SET_BUDGET"
export const ADD_BUDGET = "ADD_BUDGET"
export const UPDATE_BUDGET = "UPDATE_BUDGET"
export const DELETE_BUDGET = "DELETE_BUDGET"

export const SET_SYSTEM_MESSAGES = "SET_SYSTEM_MESSAGES"
export const ADD_SYSTEM_MESSAGE = "ADD_SYSTEM_MESSAGE"
export const UPDATE_SYSTEM_MESSAGE = "UPDATE_SYSTEM_MESSAGE"
export const DELETE_SYSTEM_MESSAGE = "DELETE_SYSTEM_MESSAGE"

export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS"
export const ADD_NOTIFICATION = "ADD_NOTIFICATION"
export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS"

export const SET_NUDGES = "SET_NUDGES"

export const SET_TOOLS = "SET_TOOLS"
export const SET_ASSIGNED_TOOLS = "SET_ASSIGNED_TOOLS"
export const ASSIGN_TOOL = "ASSIGN_TOOL"
export const UNASSIGN_TOOL = "UNASSIGN_TOOL"
